"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styles_1 = require("@material-ui/core/styles");
const Table_1 = __importDefault(require("@material-ui/core/Table"));
const TableBody_1 = __importDefault(require("@material-ui/core/TableBody"));
const TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));
const TableContainer_1 = __importDefault(require("@material-ui/core/TableContainer"));
const TableRow_1 = __importDefault(require("@material-ui/core/TableRow"));
const Paper_1 = __importDefault(require("@material-ui/core/Paper"));
const react_router_dom_1 = require("react-router-dom");
const formatDistanceToNow_1 = __importDefault(require("date-fns/formatDistanceToNow"));
const react_i18next_1 = require("react-i18next");
const withLoading_1 = require("../../hocs/withLoading");
const FavoriteContentButton_1 = __importDefault(require("../shared/FavoriteContentButton"));
const handleOnDeleteFavorite_1 = __importDefault(require("./handleOnDeleteFavorite"));
const components_1 = require("@alcumus/components");
const ReportOptionsColumn_1 = __importDefault(require("./ReportOptionsColumn"));
const date_fns_1 = require("date-fns");
const SortableTableHeader_1 = __importDefault(require("../ReportTable/SortableTableHeader"));
const ReportThumbnailRow_1 = __importDefault(require("./ReportThumbnailRow"));
const reportElementTypes_1 = require("../../../domain/reportElementTypes");
const ShowMoveFunction_1 = require("../shared/ShowMoveFunction");
const PopularityScore_1 = __importDefault(require("./PopularityScore"));
const StyledTableCell = (0, styles_1.withStyles)(() => ({
    root: {
        padding: '8px 16px',
    },
}))(TableCell_1.default);
const useStyles = (0, styles_1.makeStyles)({
    thumbnailWrapperStyle: {
        width: 85,
        height: 60,
        overflow: 'hidden',
        marginRight: 'auto',
        display: 'flex',
        border: `1px solid ${components_1.StyleVariables.colors.grey2}`,
    },
    thumbnailStyle: {
        margin: 'auto',
        width: '100%',
        height: 'auto',
    },
    tableContainer: {
        boxShadow: 'none !important',
        paddingTop: 0,
    },
    favoriteIcon: {
        paddingLeft: 32,
    },
    cellWidth: {
        width: '35%',
    },
    customNavLink: {
        color: components_1.StyleVariables.colors.text.default,
        textDecoration: 'underline',
        '&:hover': {
            color: components_1.StyleVariables.colors.text.info,
        },
    },
});
const ReportTableView = ({ id, headers, data, removeFavoriteFromTable, showLastViewed, showPopular, showViews, isLoading, emptyState, }) => {
    const [tableRow, setTableRow] = (0, react_1.useState)();
    const [sortConfig, updateSortConfig] = (0, react_1.useState)([]);
    const { t } = (0, react_i18next_1.useTranslation)();
    const sortedRows = (0, react_1.useMemo)(() => {
        if (!sortConfig.length) {
            return [...data];
        }
        function descendingComparator(a, b, orderBy) {
            if (b[orderBy] < a[orderBy])
                return -1;
            if (b[orderBy] > a[orderBy])
                return 1;
            return 0;
        }
        function getComparator(a, b, config) {
            const result = descendingComparator(a, b, config.propertyName);
            return config.sortType === 'desc' ? result : -result;
        }
        const sorted = [...data].sort((a, b) => {
            for (const config of sortConfig) {
                const result = getComparator(a, b, config);
                if (result !== 0) {
                    return result;
                }
            }
            return 0;
        });
        return sorted;
    }, [sortConfig, data]);
    const handleChange = (pendingChange) => {
        updateSortConfig([...pendingChange]);
    };
    const classes = useStyles();
    const hasContent = () => {
        return !isLoading && data.length !== 0;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TableContainer_1.default, { className: classes.tableContainer, component: Paper_1.default, "data-testid": id },
            react_1.default.createElement(Table_1.default, { "aria-label": "report table" },
                react_1.default.createElement(SortableTableHeader_1.default, { headers: headers, sortConfig: sortConfig, handleClick: handleChange }),
                hasContent() && (react_1.default.createElement(TableBody_1.default, null, sortedRows.map((row) => {
                    return (react_1.default.createElement(TableRow_1.default, { key: row.id, "data-testid": "reportRow" },
                        react_1.default.createElement(StyledTableCell, { scope: "row", align: "center" },
                            react_1.default.createElement(react_router_dom_1.NavLink, { to: row.basePath },
                                react_1.default.createElement("span", { className: classes.thumbnailWrapperStyle },
                                    react_1.default.createElement(ReportThumbnailRow_1.default, { data: { id: row.id, elementType: row.elementType } })))),
                        react_1.default.createElement(StyledTableCell, { className: classes.cellWidth, align: "left" },
                            react_1.default.createElement(react_router_dom_1.NavLink, { to: row.basePath, className: classes.customNavLink }, row.name)),
                        showPopular && (react_1.default.createElement(StyledTableCell, { align: "left" },
                            react_1.default.createElement(PopularityScore_1.default, { score: row.popularity || 0 }))),
                        showViews && (react_1.default.createElement(StyledTableCell, { align: "right" }, row.viewCount ? row.viewCount : '--')),
                        showLastViewed && (react_1.default.createElement(StyledTableCell, { align: "left" },
                            (0, date_fns_1.differenceInDays)(new Date(), row.lastViewed || new Date()) < 1
                                ? t('lessThanDay')
                                : (0, formatDistanceToNow_1.default)(row.lastViewed || 0),
                            ' ',
                            t('ago'))),
                        react_1.default.createElement(StyledTableCell, { align: "left" }, row.createdBy),
                        react_1.default.createElement(StyledTableCell, { align: "left" },
                            react_1.default.createElement(react_router_dom_1.NavLink, { to: `folders/${row.folderId}`, className: classes.customNavLink }, row.folder)),
                        react_1.default.createElement(StyledTableCell, { className: classes.favoriteIcon, align: "left" },
                            react_1.default.createElement(FavoriteContentButton_1.default, { elementType: row.elementType, liked: row.contentFavoriteId !== null, contentMetadataId: row.contentMetadataId, contentFavoriteId: row.contentFavoriteId, handleOnDeleteFavorite: (contentFavoriteId) => {
                                    if (removeFavoriteFromTable)
                                        setTableRow((0, handleOnDeleteFavorite_1.default)({
                                            content: tableRow ?? [],
                                            contentFavoriteId: contentFavoriteId,
                                        }));
                                } })),
                        (0, ShowMoveFunction_1.showKebabMenu)({ report: row }) ? (react_1.default.createElement(StyledTableCell, null,
                            react_1.default.createElement(ReportOptionsColumn_1.default, { showDownload: true, showSchedule: true, showEdit: true, showMove: (0, ShowMoveFunction_1.showMoveFunction)({ report: row }), showDelete: true, enableDelete: row.elementType === reportElementTypes_1.ReportElementTypes.Folder, row: row }))) : (react_1.default.createElement(StyledTableCell, null))));
                }))))),
        !hasContent() && emptyState));
};
exports.default = (0, withLoading_1.withSkeletonLoading)(ReportTableView);
